import { Reveal } from "../components/Motion";
import { beforeAfter } from "../lib/data";

export default function BeforeAfter() {
  return (
    <div data-testid="page-before-after">
      <section className="pt-32 md:pt-40 pb-16">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-6">До / Після</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight max-w-4xl">
              Реальні результати
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-warmGray text-lg max-w-2xl leading-relaxed">
              Кожен кадр — результат індивідуально побудованого протоколу.
              Усі фото опубліковані за згодою пацієнтів.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32 space-y-24 md:space-y-32">
        {beforeAfter.map((b, idx) => (
          <div key={b.title} className="container-luxe">
            <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-center">
              <Reveal className={`lg:col-span-8 ${idx % 2 === 1 ? "lg:order-2" : ""}`}>
                <div
                  data-testid={`ba-case-${idx}`}
                  className="relative rounded-3xl overflow-hidden border border-line bg-sand luxe-shadow"
                >
                  <img loading="lazy" decoding="async" src={b.image}
                    alt={b.title}
                    className="w-full h-auto object-contain block"
                  />
                  <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-bone/90 backdrop-blur text-ink text-[10px] tracking-[0.28em] uppercase">
                    До
                  </div>
                  <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-ink/90 backdrop-blur text-bone text-[10px] tracking-[0.28em] uppercase">
                    Після
                  </div>
                </div>
              </Reveal>
              <Reveal className={`lg:col-span-4 ${idx % 2 === 1 ? "lg:order-1" : ""}`} delay={0.1}>
                <div className="overline text-warmGray mb-3">
                  Кейс {String(idx + 1).padStart(2, "0")}
                </div>
                <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
                  {b.title}
                </h2>
                <p className="mt-6 text-warmGray leading-relaxed">{b.caption}</p>
                <div className="mt-8 inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-warmGray">
                  Фото пацієнтки · згода надана
                </div>
              </Reveal>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
